import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import {
  Button,
  Form,
  Dropdown,
  InputGroup,
  Spinner,
  Container,
} from "react-bootstrap";
import "./login.css";
import background from "../../../bg-login.png";
import logo from "../../../logo-roundQM.svg";
import axios from "axios";
import { useFormik } from "formik";
import * as Yup from "yup";
import Alert from "../../../components/Alert/Alert";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useTranslation } from "react-i18next";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import VisibilityIcon from "@mui/icons-material/Visibility";
import IconButton from "@mui/material/IconButton";
const Login = (props) => {
  const history = useHistory();
  const [loadingConnect, setLoadingConnect] = useState(false);
  const [loadingForget, setLoadingForget] = useState(false);
  const [display, setDisplay] = useState("none");
  const [type, setType] = useState("password");
  const [load, setLoad] = useState(false);
  const [message, setMessage] = useState(false);
  const { i18n, t } = useTranslation();
  const [lang, setLang] = useState("");

  //Formik
  const formik = useFormik({
    initialValues: {
      email: "",
      password: "",
    },
    validationSchema: Yup.object({
      email: Yup.string()
        .email("Veuillez entrer un email valide")
        .required("L'adresse e-mail est obligatoire"),
      password: Yup.string().required("Le mot de passe est obligatoire"),
    }),
    onSubmit: async (values) => {
      handleLogin(values);
    },
  });

  useEffect(() => {
    setLoad(true);
  }, [localStorage.getItem("access_token")]);

  const handleLogin = async (credentials) => {
    setLoadingConnect(true);
    const res = await axios
      .post(`${process.env.REACT_APP_ADMIN_API_URL}/api/users/login`, {
        email: credentials.email,
        password: credentials.password,
      })
      .then((response) => {
        if (response.data.accessToken) {
          const item = {
            nickname: `${response.data.currentUser.user.firstName} ${response.data.currentUser.user.lastName}`,
            name: response.data.currentUser.user.email,
            picture: "",
            email: response.data.currentUser.user.email,
            email_verified: true,
            ["http://role.tn/roles"]: [response.data.currentUser.role.name],
          };
          axios.defaults.headers.common["x-access-token"] = response.data
            .accessToken
            ? response.data.accessToken
            : "";
          axios.defaults.headers.common["Authorization"] = response.data
            .accessToken
            ? response.data.accessToken
            : "";
          axios.defaults.headers.common["token"] = response.data.accessToken
            ? response.data.accessToken
            : "";

          localStorage.setItem("access_token", `${response.data.accessToken}`);
          localStorage.setItem("user_auth0", JSON.stringify(item));
          item["http://role.tn/roles"][0] === "SUPER-ADMIN"
            ? localStorage.setItem(
                "profile",
                JSON.stringify(response.data.currentUser.role.name)
              )
            : localStorage.setItem(
                "profile",
                JSON.stringify(response.data.currentUser.profile)
              );
          localStorage.setItem(
            "user",
            JSON.stringify(response.data.currentUser.user)
          );

          history.push("/home");
        }
      })
      .catch((err) => {
        setDisplay("block");
        const notify = () => {
          toast("Votre mot de passe ou adresse e-mail est incorrect.", {
            position: toast.POSITION.TOP_CENTER,
            hideProgressBar: true,
            type: toast.TYPE.ERROR,
          });
        };
        notify();
      });
    setLoadingConnect(false);
  };

  const onDisplay = (display) => {
    setDisplay(display);
  };

  // ******** from login design
  const onChangeTypePassword = () => {
    if (type === "password") setType("text");
    if (type === "text") setType("password");
  };

  const passwordForget = async () => {
    setLoadingForget(true);
    if (formik.values.email) {
      await axios
        .post(
          `${process.env.REACT_APP_ADMIN_API_URL}/api/users/reset-password/resend`,
          { email: formik.values.email }
        )
        .then((response) => {
          setDisplay("block");
          const notify = async () => {
            toast("Un email de réinitialisation de mot de passe est envoyé", {
              position: toast.POSITION.TOP_CENTER,
              hideProgressBar: true,
              type: toast.TYPE.SUCCESS,
            });
          };
          notify();
        })
        .catch((err) => {
          toast(err.response.data.message, {
            position: toast.POSITION.TOP_CENTER,
            hideProgressBar: true,
            type: toast.TYPE.ERROR,
          });
        });
    } else {
      toast("Veuillez saisir votre adresse électronique", {
        position: toast.POSITION.TOP_CENTER,
        hideProgressBar: true,
        type: toast.TYPE.ERROR,
      });
    }

    setLoadingForget(false);
  };
  const langOptions = [
    { name: "Français" },
    { name: "Anglais" },
    { name: "Arabe" },
  ];

  const change = (eventkey) => {
    setLang(eventkey);
    i18n.changeLanguage(eventkey);
  };
  return (
    <div>
      <ToastContainer />
      <div className="login-logo">
        <p className="login-logo-title">
          Round <p className="login-logo_subtitle">QUALITY MONITORING</p>
        </p>
        <img
          style={{ maxWidth: "25%", paddingBottom: 40 }}
          src={logo}
          alt="Logo"
        />
      </div>
      <div className="split left">
        <div className="centered">
          <div>
            <p
              className="login-welcome-text"
              style={{ color: "#B7B7B7", fontFamily: "Gilroy" }}
            >
              {t("common.welcome")}
              <span className="login-roundesk-title">Roundesk !</span>
            </p>
          </div>
          <Form
            noValidate
            onSubmit={formik.handleSubmit}
            className="form-login"
          >
            <div className="logins">
              <Form.Control
                className="form-control input-sm"
                maxLength="64"
                placeholder="E-mail"
                type="text"
                name="email"
                id="email"
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.email}
              />
              {formik.touched.email && formik.errors.email ? (
                <div className="text-danger">{formik.errors.email}</div>
              ) : null}
              <InputGroup className="input-group-login">
                <Form.Control
                  type={type}
                  className="form-control form-control-login"
                  maxLength="64"
                  placeholder={t("common.password-placeholder")}
                  id="password"
                  name="password"
                  autoComplete={formik.values.password}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.password}
                />
                <IconButton
                  className="password-visibility-icon"
                  onClick={onChangeTypePassword}
                >
                  {type === "password" ? (
                    <VisibilityOffIcon />
                  ) : (
                    <VisibilityIcon />
                  )}
                </IconButton>
              </InputGroup>
              {formik.touched.password && formik.errors.password ? (
                <div className="text-danger">{formik.errors.password}</div>
              ) : null}
            </div>
            {!loadingForget ? (
              <p className="forgetPassword" onClick={passwordForget}>
                {t("common.forget-password")}
              </p>
            ) : (
              <Container className="d-flex justify-content-center align-items-center my-3 forgetPassword">
                <Spinner animation="border" size="sm" role="status" />
              </Container>
            )}
            <Button
              className="btn-secondary1 btn-login mt-3"
              variant="primary"
              type="submit"
              onClick={() => {
                handleLogin();
              }}
            >
              {t("common.connect-button")}
              {loadingConnect && (
                <>
                  &nbsp;
                  <span className="spinner-border spinner-border-sm"></span>
                </>
              )}
            </Button>
          </Form>

          {message && (
            <Alert
              message={message}
              status={"danger"}
              marginTop={"8rem"}
              display={display}
              onDisplay={onDisplay}
            />
          )}
        </div>
        <div className="footer-login-page ">
          <div>
            <span>Roundesk 2024 </span>-{" "}
            <span>{t("common.allrights-phone")} : 01 76 234 234</span>
          </div>
        </div>
      </div>

      <div
        className="split right"
        style={{ backgroundImage: `url(${background})` }}
      >
        <Dropdown onSelect={change}>
          <Dropdown.Toggle className="select-btn" id="dropdown-basic">
            {lang === "en" ? (
              <img
                className="flag-img"
                src="https://upload.wikimedia.org/wikipedia/commons/thumb/1/13/United-kingdom_flag_icon_round.svg/1200px-United-kingdom_flag_icon_round.svg.png"
              />
            ) : (
              <img
                className="flag-img"
                src="https://vectorflags.s3.amazonaws.com/flags/fr-circle-01.png"
              />
            )}
            <span>
              {lang === "fr"
                ? "Français"
                : lang === "en"
                ? "Anglais"
                : "Français"}
            </span>
          </Dropdown.Toggle>

          <Dropdown.Menu>
            <Dropdown.Item eventKey="fr">
              <img
                src="https://vectorflags.s3.amazonaws.com/flags/fr-circle-01.png"
                className="flag-img flag-img-item"
              />
              <span className="spacing">Français</span>
              <label className="container container-checkbox">
                <input
                  value="fr"
                  type="radio"
                  checked={lang === "fr"}
                  name="langue"
                />
                <span className="checkmark"></span>
              </label>
            </Dropdown.Item>
            <Dropdown.Item eventKey="en">
              <img
                src="https://upload.wikimedia.org/wikipedia/commons/thumb/1/13/United-kingdom_flag_icon_round.svg/1200px-United-kingdom_flag_icon_round.svg.png"
                className="flag-img flag-img-item"
              />
              <span className="spacing">Anglais</span>{" "}
              <label className="container container-checkbox">
                <input
                  value="en"
                  type="radio"
                  name="langue"
                  checked={lang === "en"}
                />
                <span className="checkmark"></span>
              </label>{" "}
            </Dropdown.Item>
          </Dropdown.Menu>
        </Dropdown>

        <h1 className="slogan">{t("common.login-quote")}</h1>
      </div>
    </div>
  );
};

export default Login;
